<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" plain @click="setPassword">初始密码</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button
              v-if="$permission.canWrite()"
              type="text"
              @click="edit(row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" urlHash="sys/user" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/sys/user/list";
import editDialog from "@/components/sys/user/editDialog";

export default {
  name: "user",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/sy/user").default,
    };
  },
  methods: {
    // logout(row) {
    //   this.$confirm("确认注销已登录的用户吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       this.$refs.list.logout(row);
    //     })
    //     .catch(() => {});
    // },

    setPassword() {
      console.log("setPassword");
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要初始化密码的用户");
        return;
      }
      let ids = rows.map((item) => {
        return item.UserId;
      });
      this.api.initPwd({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("设置成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.UserId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>